<div *ngIf="!isReferralLoading" style="display: flex; flex-direction: column; height: 100vh;">
  <div
    style="width: 100%; height: 60px; background-color: #fff;padding: 16px; display: flex; justify-content: space-between; align-items: center; margin-top: 16px;">

    <div style="display: flex; flex-direction: column; justify-content: center; ">
      <div class="heading" style="margin-top:0px">Referral</div>
      <div class="subheading" style="width: 100%;">You can create referral for this patient by tapping 'Create Referral'
        Button</div>
    </div>

    <div style="display: flex;flex-direction: row;">
      <button (click)="createReferral();" class="new_btn btnUi" style="margin-left: 10px;">Create Referral</button>

    </div>
  </div>
  <!-- DATA -->
  <div *ngIf="allReferrals?.length > 0" style="padding: 20px;">
    <ng-container [ngTemplateOutlet]="renderMilestones" [ngTemplateOutletContext]="{ value: allReferrals }">
    </ng-container>
  </div>
  <!-- EMPTY -->
  <div *ngIf="!allReferrals?.length" style="padding: 20px;">
    <app-empty-state-placeholder [title]="'Referral History'" [subtitle]="'No referrals found for this patient'"
      [icon]="'assets/images/placeholder.svg'">
    </app-empty-state-placeholder>
  </div>
</div>
<ng-template #renderMilestones let-value="value">
  <table mat-table [dataSource]="value" style="width: 100%;">

    <!-- Sr No -->
    <ng-container matColumnDef="sr no">
      <th class="tableHeading" mat-header-cell *matHeaderCellDef style="width:10%">Sr No</th>
      <td class="tableData" mat-cell *matCellDef="let element; let i = index" style="text-align:center; width:10%">
        {{ i + 1 }}
      </td>
    </ng-container>

    <!-- Date -->
    <ng-container matColumnDef="date">
      <th class="tableHeading" mat-header-cell *matHeaderCellDef style="width:15%">Date</th>
      <td class="tableData" mat-cell *matCellDef="let element" style="text-align:center;">
        {{ element?.documentDate | date:'dd/MM/yyyy' }}
      </td>
    </ng-container>

    <!-- Document Type -->
    <ng-container matColumnDef="document type">
      <th class="tableHeading" mat-header-cell *matHeaderCellDef>Document Type</th>
      <td class="tableData" mat-cell *matCellDef="let element" style="text-align:center;">
        {{ element?.documentType }}
      </td>
    </ng-container>

    <!-- Uploaded By -->
    <ng-container matColumnDef="uploaded by">
      <th class="tableHeading" mat-header-cell *matHeaderCellDef style="width:20%">
        Uploaded By
      </th>
      <td class="tableData" mat-cell *matCellDef="let element" style="text-align:center;">
        {{ drString }}{{ element?.uploadedB || 'Doctor' }}
      </td>
    </ng-container>

    <!-- View -->
    <ng-container matColumnDef="preview">
      <th class="tableHeading" mat-header-cell *matHeaderCellDef style="width:15%">
        View
      </th>
      <td class="tableData" mat-cell *matCellDef="let element" style="text-align:center;">
        <div class="actionBtn" (click)="onClickViewRert(element)">
          View
        </div>
      </td>
    </ng-container>

    <!-- Header + Rows -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="background-color:#eee;">
    </tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</ng-template>
<div *ngIf="isReferralLoading" class="loader-overlay">
  <div class="loader-content">
    <img alt="Logo" width="75px" src="assets/images/new_logo.svg">
    <h6 style="margin-top: 10px;">Referral is Loading....</h6>
  </div>
</div>
<ng-template #addReferralModal let-modal>
  <form #refForm="ngForm">
    <div class="addReferralModal referral-scope">
      <!-- HEADER -->
      <div class="modal-header-custom">
        <!-- your existing header code -->
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="display: flex; align-items: center; gap: 15px;">
            <div class="icon-box">
              <i class="fa fa-user-plus icon-blue"></i>
            </div>
            <div>
              <h4 style="margin: 0; font-size: 18px; font-weight: 700; padding-bottom: 8px;">Referral</h4>
              <span
                style="background: #e0f2fe; color: #0369a1; padding: 4px 10px; border-radius: 6px; font-size: 12px; font-weight: 600;">
                {{ patientFullName | titlecase }} {{patientAge}}
              </span>
            </div>
          </div>

          <div style="display: flex; align-items: center; gap: 60px;">
            <div ngbDropdown>
              <button
                style="background: none; border: none; border-bottom: 1px solid #ccc; cursor: pointer; padding: 5px;"
                ngbDropdownToggle>
                {{templateName}}
              </button>
              <div ngbDropdownMenu>
                <button *ngFor="let item of selectedTemplate" (click)="onDropdownSelectTemplate(item)"
                  ngbDropdownItem>{{item}}</button>
              </div>
            </div>
            <button style="background: none; border: none; font-size: 30px; cursor: pointer;"
              (click)="closeDialog()">&times;</button>
          </div>
        </div>

      </div>
      <!-- SCROLLABLE CONTENT -->
      <div class="modal-body-custom referral-scope">
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-top: 20px;">

          <div style="border-right: 1px solid #f1f5f9; padding-right: 30px;">
            <h6 style="font-size: 11px; color: #06b6d4; letter-spacing: 1px; margin-bottom: 5px;padding: 5px;">●
              RECIPIENT
              DETAILS</h6>

            <div class="custom-roundCard">

              <!-- Doctor Name -->
              <mat-form-field appearance="outline" class="custom-mat-field"
                [ngClass]="{'force-error':docNameRef?.invalid &&(docNameRef?.touched || refForm.submitted)}">
                <mat-label> <span> &nbsp;</span> Dr. <span> &nbsp;</span> </mat-label>
                <input matInput [(ngModel)]="docNamee" #docNameRef="ngModel" name="docName" required
                  (keypress)="onlyAlphabets($event)">
              </mat-form-field>

              <!-- Mobile -->
              <mat-form-field appearance="outline" class="custom-mat-field"
                [ngClass]="{'force-error':mobRef?.invalid &&(mobRef?.touched || refForm.submitted)}">
                <mat-label> <span> &nbsp;</span> Mobile</mat-label>
                <input matInput maxlength="10" inputmode="numeric" [(ngModel)]="docMobNumber" #mobRef="ngModel"
                  name="mobile" required minlength="10" (keypress)="onlyNumbers($event)">
              </mat-form-field>

              <!-- Email -->
              <mat-form-field appearance="outline" class="custom-mat-field">
                <mat-label> <span> &nbsp;</span> Email Id <span> &nbsp;</span> </mat-label>
                <input matInput type="email" [(ngModel)]="docEmail" name="email" #emailRef="ngModel" email>
              </mat-form-field>

            </div>
          </div>
          <div>
            <h6 style="font-size: 11px; color: #3b82f6; letter-spacing: 1px; margin-bottom: 5px;padding: 5px;">●
              CLINICAL
              DETAILS</h6>
            <div class="custom-roundCard">

              <mat-form-field appearance="outline" class="custom-mat-field" style="width: 100%;"
                [ngClass]="{'force-error':complaintRef?.invalid &&(complaintRef?.touched || refForm.submitted)}">
                <mat-label> <span> &nbsp;</span> Present Complaints * <span> &nbsp;</span> </mat-label>
                <textarea matInput rows="3" [(ngModel)]="presentComplaints" #complaintRef="ngModel" required
                  name="complaints">
    </textarea>

              </mat-form-field>

              <div style="display: flex; gap: 10px; align-items: center;">

                <mat-form-field appearance="outline" class="custom-mat-field durationInputField"
                  style="width: 100px; margin-top: 22px; width: 115px !important;">
                  <mat-label> <span> &nbsp;</span> Duration <span> &nbsp;</span> </mat-label>
                  <input matInput type="number" [(ngModel)]="duration" [ngModelOptions]="{standalone: true}" min="1">

                </mat-form-field>

                <div
                  style="display: flex; background: #f1f5f9; padding: 3px; border-radius: 50px; flex-grow: 1; border: 1px solid #e2e8f0;">

                  <button *ngFor="let item of dayWeeksArray; let i = index" (click)="switchDaysWeeks(i)"
                    [style.background]="item.selected ? '#fff' : 'transparent'"
                    [style.color]="item.selected ? '#3b82f6' : '#94a3b8'"
                    style="flex: 1; border: none; font-size: 10px; font-weight: 700; cursor: pointer; border-radius: 50px; padding: 8px;">
                    {{item.name | uppercase}}
                  </button>

                </div>

              </div>

            </div>
          </div>
        </div>
        <div style="    overflow: auto;
    height: 43%; scrollbar-width: thin;">
          <div
            style="background: #f0f9ff; border: 1px solid #d0e7ff; border-radius: 12px; padding: 20px; margin-top: 10px;">
            <div style="display: flex; justify-content: space-between;">
              <div
                style="display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 800; color: #64748b;">
                <i class="fa fa-eye" style="color: #939393 !important;"></i> PREVIEW
              </div>
              <div>
                <div style="color: #8B8B8B; font-size: 16px;">(Editable)</div>
              </div>
            </div>
            <div class="text-area-style" id="refeeral" contentEditable="true" class="preview-text-area">

              For your expert opinion and advice<br>

              {{ genderHe || 'She' }} has
              <span class="highlight-text">
                {{ presentComplaints || '' }}
              </span>
              <span *ngIf="duration">
                since {{ duration }} {{ daysWeeks }}
              </span>.


              Kindly, advice.<br>

              Also, any investigation (if needed) and further course of treatment
              <br>


              Thanking you,<br>

              I can share a detailed history of the patient if required.

            </div>
          </div>
        </div>

      </div>

      <!-- FIXED FOOTER -->
      <div class="modal-footer-custom">
        <button class="btnUi" (click)="printNewRefreel('preview', refForm)">
          Preview <i class="fa fa-paper-plane" style="margin-left: 8px;"></i>
        </button>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #viewDocumentsModal let-modal>
  <div class="referral-container">
    <!-- HEADER -->
    <div class="modal-header">
      <h4 class="modal-title">View Document</h4>
      <button type="button" class="close" style="outline: none; border-width: 0px;" (click)="closeDialog()">
        <span style="font-size: 40px;">&times;</span>
      </button>
    </div>
    <!-- BODY -->
    <div class="modal-body">
      <embed [attr.src]="documentPdfURL" type="application/pdf" class="pdf-viewer">
    </div>

  </div>
</ng-template>

<ng-template #viewReferralModal let-modal>
  <div class="referral-container">

    <!-- ✅ HEADER (UNCHANGED) -->
    <div class="modal-header" style="border-bottom: none; padding-bottom: 0;">
      <h4 class="modal-title">Referral</h4>
      <button type="button" class="close" style="outline: none; border-width: 0px;" mat-dialog-close>
        <span style="font-size: 40px;">&times;</span>
      </button>
    </div>

    <!-- ✅ BODY (FIXED) -->
    <div class="modal-body">
      <embed [attr.src]="refreelcertiPdfURL" type="application/pdf" class="pdf-viewer">
    </div>

    <!-- ✅ FOOTER (UNCHANGED) -->
    <div class="modal-footer">
      <div style="display: flex; justify-content: flex-end; gap: 10px;">

        <button mat-dialog-close type="button" class="btnUi" style="background-color:#f1f1f1; color:#333;">
          Back to Edit
        </button>

        <div (click)="printNewRefreel('share');closeDialog();" class="btnUi">
          Save & Share
        </div>

      </div>
    </div>

  </div>
</ng-template>

<p-toast position="top-right" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class=" p-flex p-flex-column"
      style="flex: 1; background-color:#BAE8FC; opacity: 0.95; display: flex; flex-direction: row; align-items: center; border-left: 8px solid #0D8CCD; border-radius: 8px;">
      <div>
        <img (click)="goBack()" style="height: 36px; margin-left: 12px; width: 36px; align-self: center;"
          src="assets/images/exclamation-circle-blue.svg" alt="" />
      </div>
      <div class=" p-text-center">
        <div style="font-size: 18px;
                    font-weight: bold;
                    padding: 12px 0px 0px 12px;
                    
                    color: #034A70;">{{message.summary}}</div>
        <div style="padding-left: 12px; padding-bottom: 12px; color: #034A70; font-size: 16px; margin-top: -6px;">
          {{message.detail}}</div>
      </div>
    </div>
  </ng-template>
</p-toast>